exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-message[data-v-140bc9ca]{width:100%;margin:0;padding:.75em 1em}", ""]);

// exports
